import {catchError, from, map, switchMap, tap} from 'rxjs';
import {AxiosError} from 'axios';
import {setEntities} from '@ngneat/elf-entities';
import APIAxios, {APIRoutes} from '@api/axios.api';
import SnackError from '@utils/error.utils';
import {issueKindsStore} from '@store/settings/issueKinds/issueKinds.store';
import {IssueKind} from '@store/operations/issues';
import {getIssueKindDataSource} from '@store/settings/issueKinds/issueKinds.requests';

export class IssueKindsServices {
  store = issueKindsStore;

  resetStore = () => this.store.reset();

  getIssueKinds = () => {
    return from(APIAxios({
      ...APIRoutes.GETAllIssueKinds()
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: any) => {
          return response.data;
        }),
        tap((issueKinds) => {
          this.store.update(
            setEntities(issueKinds),
            getIssueKindDataSource.setSuccess(),
          );
        }),
        getIssueKindDataSource.trackRequestStatus(),
      );
  };

  createIssueKind = (data: Partial<IssueKind>) => {
    return from(APIAxios({
      ...APIRoutes.POSTIssueKind(),
      data,
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        switchMap(() => this.getIssueKinds()),
      );
  };
  updateIssueKind = (issueKindId: number, data: Partial<IssueKind>) => {
    return from(APIAxios({
      ...APIRoutes.PATCHIssueKind(issueKindId),
      data,
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        switchMap(() => this.getIssueKinds()),
      );
  };
  deleteIssueKind = (issueKindId: number | string) => {
    return from(APIAxios(APIRoutes.DELETEIssueKind(issueKindId)))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        switchMap(() => this.getIssueKinds()),
      );
  };
}

export const issueKindsService = new IssueKindsServices();
